import { render } from "./Thinking3.vue?vue&type=template&id=e2ca7d7a"
import script from "./Thinking3.vue?vue&type=script&lang=js"
export * from "./Thinking3.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__